/** Unwraps axios { data: ApiEnvelope } where ApiEnvelope may be { data: T } or T. */
export function unwrapBusinessResponse<T = unknown>(response: {
  data?: unknown;
}): T | null {
  const root = response?.data as Record<string, unknown> | undefined;
  if (!root || typeof root !== "object") {
    return null;
  }
  if ("data" in root && root.data !== undefined) {
    return root.data as T;
  }
  return root as T;
}
